import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'

export default class OffersSwiper extends HTMLElement {
    swiperConf = {
        slidesPerView: 1,
        spaceBetween: 15,
        modules: [Navigation],
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        breakpoints: {
            320: {
                slidesPerView: 1.4
            },
            425: {
                slidesPerView: 1.5
            },
            480: {
                slidesPerView: 1.8
            },
            768: {
                slidesPerView: 2.3,
                spaceBetween: 20
            },
            900: {
                slidesPerView: 2.6,
                spaceBetween: 20
            },
            1024: {
                slidesPerView: 2.8,
                spaceBetween: 25
            },
            1200: {
                slidesPerView: 3.1,
                spaceBetween: 25
            }
        }
    }
    swiperInst: Swiper | null = null

    constructor() {
        super()
    }

    onWindowResize() {
        setTimeout(() => {
            console.log('this--> : ', this.getBoundingClientRect().width)
        }, 100)
    }

    init() {
        this.style.setProperty('display', 'block')
        this.swiperInst = new Swiper(this, this.swiperConf)
        this.swiperInst.slidesPerViewDynamic()

        window.addEventListener('resize', () => {
            this.swiperInst?.update()
            this.onWindowResize()
        })
    }

    connectedCallback() {
        setTimeout(() => {
            this.init()
        })
    }
}
